export const PageLoading = () => {
  return null;
};
